export function downloadPdf(arraybuffer, fileName) {
	const blob = new Blob([arraybuffer], { type: "application/pdf" });
	const url = URL.createObjectURL(blob);

	const downloadLink = document.createElement("a");
	downloadLink.href = url;
	downloadLink.download = fileName;
	downloadLink.click();
    URL.revokeObjectURL(url);
    return downloadLink;
}
